import { Fab, withStyles } from "@material-ui/core";

export const StyledFAB = withStyles((theme) => ({
    root: {
        position: "fixed",
        right: theme.spacing(1),
        bottom: theme.spacing(1)
    },
    primary: {
        backgroundColor: "#BBDEFB",
        color: "#2196F3"
    }
}))(Fab);